import React, { FC } from 'react';
import styled from 'styled-components';
import Text from 'Components/Typography/Text';
import Flex from 'Components/Grid/Flex';
import { FontSize, FontWeight } from 'theme';
import ExternalLink from 'Components/ExternalLink';
import { useSelector } from 'react-redux';
import { getCurrentCity } from 'Modules/SearchAddress/selectors';
import { phoneFormat } from 'utils/helpers';
import SocialsList from 'Components/Footer/SocialsList';
import { colors } from 'constants/colors';

const Time = styled(Text)`
  display: block;
`;

const Contacts: FC<{ className?: string }> = ({ className }) => {
  const currentCity = useSelector(getCurrentCity);

  return (
    <div className={className}>
      {currentCity?.phone && (
        <ExternalLink href={`tel:${currentCity.phone}`}>
          <Text size={FontSize.m} fontWeight={FontWeight.semiBold} $nowrap>
            {`8 ${phoneFormat(currentCity.phone)}`}
          </Text>
        </ExternalLink>
      )}
      <Time size={FontSize.s}>с 10:00 до 22:00 ежедневно</Time>
      <Flex mt={6} mtXs={4}>
        <SocialsList bgColor={colors.lightGreyGreenThree} />
      </Flex>
    </div>
  );
};

export default Contacts;
